import { type Height, type ItemDimensions } from '@atlassian/company-hub-common';

import { CardsLayout } from '../../../../../types';

import { cardsDimensionsFixed, cardsDimensionsFlexible } from './constants';

/**
 * Card dimensions for flexible and fixed image height layouts
 *
 * - The max number of cards per row determines the min width of different card sizes
 * - The max width is used in case the first row is not full
 */

type getCardComponentProps = {
	cardSize: Height;
	layout?: CardsLayout;
};

export const getCardDimensions = ({ cardSize, layout }: getCardComponentProps): ItemDimensions => {
	if (layout === CardsLayout.FIXED_IMAGE_HEIGHT) {
		return cardsDimensionsFixed[cardSize];
	}

	// Default to flexible dimensions (used for FLEXIBLE_IMAGE_HEIGHT and undefined layout)
	return cardsDimensionsFlexible[cardSize];
};
